/**
 * Auth Layout - For login/register pages
 * Animated background, floating widgets, professional entrance.
 * For Media Devoted | Created By Ciro Autiero
 */

import { Outlet } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';

import { AuthBackgroundEffects } from '@/features/auth/components';

export function AuthLayout() {
  const prefersReducedMotion = useReducedMotion();

  const outletVariants = {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: prefersReducedMotion ? 0 : 0.6,
        delay: prefersReducedMotion ? 0 : 0.12,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <div className="relative flex h-full min-h-screen items-center justify-center overflow-y-auto overflow-x-hidden px-4 py-8">
      <AuthBackgroundEffects />
      <motion.main
        variants={outletVariants}
        initial="hidden"
        animate="visible"
        className="relative z-10 w-full max-w-5xl"
      >
        <Outlet />
      </motion.main>
    </div>
  );
}
